import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ContactTargetQueryCriteriaClass extends BaseCriteriaModel {
  // Hdr
  key_guid?: Optional<string> = Optional.empty();
  contact_hdr_guid?: Optional<string> = Optional.empty();
  link_type?: Optional<string> = Optional.empty();
  target_hdr_table?: Optional<string> = Optional.empty();
  target_hdr_guid?: Optional<string> = Optional.empty();
  target_line_guid?: Optional<string> = Optional.empty();
  target_line_table?: Optional<string> = Optional.empty();
  probability?: Optional<number> = Optional.empty();

}

export class ContactTargetCriteriaModelQuery {
  query = '';

  constructor(contactTargetCriteriaModel: ContactTargetQueryCriteriaClass) {

    if (!contactTargetCriteriaModel) {
      return;
    }

    this.query += contactTargetCriteriaModel.key_guid.filter(x => x !== '').map(x => '&key_guid=' + x).orElse('');
    this.query += contactTargetCriteriaModel.contact_hdr_guid.filter(x => x !== '').map(x => '&contact_hdr_guid=' + x).orElse('');
    this.query += contactTargetCriteriaModel.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');
    this.query += contactTargetCriteriaModel.target_hdr_table.filter(x => x !== '').map(x => '&target_hdr_table=' + x).orElse('');
    this.query += contactTargetCriteriaModel.target_hdr_guid.filter(x => x !== '').map(x => '&target_hdr_guid=' + x).orElse('');
    this.query += contactTargetCriteriaModel.target_line_guid.filter(x => x !== '').map(x => '&target_line_guid=' + x).orElse('');
    this.query += contactTargetCriteriaModel.target_line_table.filter(x => x !== '').map(x => '&target_line_table=' + x).orElse('');
    this.query += contactTargetCriteriaModel.probability.filter(x => x !== null).map(x => '&probability=' + x).orElse('');


    this.query += '&status=' + contactTargetCriteriaModel.status;
    this.query += '&orderBy=' + contactTargetCriteriaModel.orderBy;
    this.query += '&order=' + contactTargetCriteriaModel.order;
    this.query += '&offset=' + contactTargetCriteriaModel.offset + '&limit=' + contactTargetCriteriaModel.limit;
  }
}
